// extracted by mini-css-extract-plugin
export default {"title":"Y41F3","container":"gtjlW","subContainer":"GwQdq","header":"JTPP5","screenreaderOnly":"mH_dy","pill":"PNSTR"};